<ng-container *ngIf="translationServiceReady">
  <header *ngIf="isLoggedIn()">
    <app-topbar *ngIf="isLoggedIn()"></app-topbar>
  </header>

  <div class="main" *ngIf="isLoggedIn()" id="main-div">
    <app-tabs *ngIf="shouldShowTabs()"></app-tabs>
    <div class="window">
      <ng-container *ngIf="isContentShown()">
        <router-outlet></router-outlet>
      </ng-container>
    </div>
  </div>

  <footer *ngIf="isLoggedIn()">
    <p>anessa  | <a class="mail-link" href="mailto:support@anessa.com" anessaTranslation="COMMON.CONTACT"></a> </p>
  </footer>

  <div *ngIf="!isLoggedIn()">
    <router-outlet></router-outlet>
  </div>

  <ngx-guided-tour progressIndicatorLocation="hidden"></ngx-guided-tour>
</ng-container>
